var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({ref:"cascader",staticClass:"w-100p",attrs:{"separator":"-","props":{..._vm.defaultProps , ..._vm.props},"clearable":""},on:{"change":_vm.cascaderChange},model:{value:(_vm.locations),callback:function ($$v) {_vm.locations=$$v},expression:"locations"}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }